import EmblaCarousel, { EmblaCarouselType, EmblaOptionsType } from 'embla-carousel';

export default class ProductCarousel {
    private readonly embla: EmblaCarouselType;
    private readonly mediaQueries: CarouselMediaQuery[] = [{
        media: '(min-width: 1000px)',
        onMatch() {
            return {
                slidesToScroll: 4,
            };
        },
    }, {
        media: '(max-width: 999px)',
        onMatch() {
            return {
                slidesToScroll: 2,
            };
        },
    }, {
        media: '(max-width: 599px)',
        onMatch() {
            return {
                slidesToScroll: 1,
            };
        },
    }];

    constructor(container: HTMLElement) {
        this.embla = EmblaCarousel(container, {
            containScroll: 'trimSnaps',
        });
        this.mediaQueries.forEach(({ media, onMatch }) => {
            const mediaQuery = matchMedia(media);
            const update = () => {
                if (mediaQuery.matches) {
                    const newOptions = onMatch(this.embla, this);

                    if (newOptions !== undefined) {
                        this.embla.reInit(newOptions);
                    }
                }
            };

            mediaQuery.addListener(update);
            update();
        });
    }

    static createFromSelector(selector: string) {
        return Array.from(document.querySelectorAll<HTMLElement>(selector)).map(container => {
            return new ProductCarousel(container);
        });
    }
}

type CarouselMediaQuery = {
    media: string,
    onMatch(embla: EmblaCarouselType, carousel: ProductCarousel): EmblaOptionsType | void,
};
